import React from 'react';
import { ActionMenu, resolveMenuItems } from '@milanote/roma/application';
import type { MenuSize } from '@milanote/roma';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { useSelector } from 'react-redux';
import { userLocalePreferenceSelector } from '../../../../../../user/currentUserSelector';
import { insertMenuConfig, InsertMenuContext } from './insertMenuPopupConfig';
import useDividerAction from './useDividerAction';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';

export type InsertMenuToolbarPopupProps = {
    closePopup: () => void;
    size: MenuSize;
    onLinkBoard: () => void;
    element?: ImMNElement;
};

const InsertMenuToolbarContent: React.FC<InsertMenuToolbarPopupProps> = ({
    closePopup,
    size = 'xs',
    onLinkBoard,
    element,
}) => {
    const translate = useTranslator('toolbar', 'tools.editing.insertMenu') as (localeKey: string) => string;
    const locale: string = useSelector(userLocalePreferenceSelector);

    const insertDividerLine = useDividerAction();

    const popupAction = (action: () => void) => () => {
        closePopup();
        action();
    };

    const context: InsertMenuContext = {
        translate,
        locale,
        element,
        // TODO: Proper actions to be added in separate tickets
        insertEmoji: closePopup,
        insertBoardLink: popupAction(onLinkBoard),
        insertDividerLine: popupAction(insertDividerLine),
        insertMention: closePopup,
    };

    const nodes = resolveMenuItems(insertMenuConfig, context);

    return <ActionMenu.Content aria-label="Insert menu actions" nodes={nodes} autoFocus size={size} showIcons />;
};

export default InsertMenuToolbarContent;
